import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store';
import { selectUser } from 'store/selectors/me/user';
import { resetMe } from 'store/slices/me';
import Heading from 'storybookConfig/stories/molecules/Heading';
import AuthLayout from 'storybookConfig/stories/species/Layout/AuthLayout';
import { logMeOut } from 'utils/api/auth';
import { destroyAuthCookies } from 'utils/cookies';

const LogoutPage = () => {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();

  // Destructure the isLoading and mutate function from the useMutation hook
  // because the result of useMutation is not stable and the mutation must run
  // immediately and only once on mount.
  const { isLoading, mutate: logOut } = useMutation({
    mutationFn: () => logMeOut(),
    onSettled: () => {
      destroyAuthCookies();
      dispatch(resetMe());
    },
  });

  useEffect(() => {
    logOut();
  }, [logOut]);

  if (isLoading || user !== null)
    return (
      <AuthLayout>
        <Heading variant="Headings/H1">Logging out...</Heading>
      </AuthLayout>
    );

  // Replace /logout: left in history, Back would log out again and bounce to sign-in.
  return <Navigate to="/signin" replace />;
};

export default LogoutPage;
